<button
  type="button"
  aria-label="Toggle navigation menu"
  class="toggle-sidenav"
  [class]="{ active: isNavbarOpened }"
  (click)="toggleSidenav(sidenav)"
  id="dashboard-navbar-toggle-button"
  >
  <mat-icon>menu</mat-icon>
</button>
  <mat-sidenav-container class="container">
    <mat-sidenav
      class="sidenav"
      [mode]="(isSmallScreen | async) ? 'over' : 'side'"
        [opened]="
            (isSmallScreen | async) === false ||
            (isSmallScreen | async) === undefined
        "
      [fixedInViewport]="isSmallScreen | async"
      [fixedTopGap]="65"
      (click)="onMenuSelect()"
      id="dashboard-navbar-sidenav"
      >
      <octo-nav-menu></octo-nav-menu>
    </mat-sidenav>
    <mat-sidenav-content class="content-inner-wrapper">
      <router-outlet></router-outlet>
      <footer id="dashboard-footer" class="footer">
        <img src="assets/images/play-octopus-logo.png" alt="Octopus Logo" />
        <p>
          If you have questions or feedback on our driver dashboard,
          please go
          <a
            class="black-link"
            href="https://playoctopus.com/help/"
            target="_blank"
            >here</a
            >.
          </p>
          @if (
            userSummary?.status ===
            'Active Driver && !userSummary?.flexdrive_status'
            ) {
            <p
              >
              Check out our
              <a
                class="black-link"
                id="dashboard-navbar-facebook-group-link"
                href="https://facebook.com/groups/playoctopus/"
                >private Facebook group</a
                >
                today.
              </p>
            }
          </footer>
        </mat-sidenav-content>
      </mat-sidenav-container>
